import { useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

export const AutomationImage = () => {
    const intl = useIntl();

    const messages = {
        altText: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Automation.altText",
            defaultMessage: "Example of automation triggers"
        })
    };

    return (
        <img
            src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.webp"
            alt={messages.altText}
            height={350}
            loading="lazy"
        />
    );
};

const Automation = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/platform/automation"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Automation.header",
            defaultMessage: "Automation"
        }),
        body: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.Automation.body",
                defaultMessage:
                    "<p>Automate any task or process in a few clicks. Set automation rules within a single project, across multiple projects or across all projects on your site to help you scale. Save time and keep your team focussed with Jira’s no-code automation engine.</p><p>Free plan comes with 500 rules per month while Standard plan has 5000. Premium has 1000 rules per user per month. For example, 200 users on Premium plan would have 200,000 rules per month for Jira Service Management pooled across users.</p><p>The Enterprise plan allows unlimited rule runs on Jira Service Management.</p><p>You only pay for what you use- only automations that successfully perform an action count towards your limit.</p>"
            },
            {
                ...DEFAULT_VALUES
            }
        ),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.Automation.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about automation."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <div>
            <h2>{messages.header}</h2>
            <>{messages.body}</>
            <p>{messages.link}</p>
            <AutomationImage />
        </div>
    );
};

export default Automation;
